import React, { useState, useEffect, useCallback } from "react";
import Breadcrumbs from "../components/common/breadcrumb";
import { Row, Col, Card, CardBody, Spinner, Button } from "reactstrap";
import { useParams } from "react-router-dom";
import {
  getInfluencerDetails,
  assignProductsToInfluencer,
  getInfluencerOrderDetails,
} from "../services/InfluencerServices";
import AssignProductsModal from "./AssignProductsModal";
import { toast } from "react-toastify";
import { formatPhoneNumber, formatDate } from "../utils";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import { Link } from "react-router-dom";
import Moment from "react-moment";
import ToolkitProvider, { CSVExport } from "react-bootstrap-table2-toolkit";
import DateRangePicker from "@wojtekmaj/react-daterange-picker";
import moment from "moment";

const columns = [
  {
    dataField: "group_id",
    text: "Group ID",
    formatter: (cell, row) => {
      return <Link to={`/app/groups/view/${row.id}`}>{cell}</Link>;
    },
  },
  {
    dataField: "offer_name",
    text: "Group Name",
  },
  {
    dataField: "total_orders",
    text: "Total Orders",
  },
  {
    dataField: "status",
    text: "Group Status",
  },
  {
    dataField: "start_date",
    text: "Start Date",
    formatter: (cell, row) => {
      return <Moment format="MM/DD/YYYY">{cell}</Moment>;
    },
  },
  {
    dataField: "end_date",
    text: "End Date",
    formatter: (cell, row) => {
      return <Moment format="MM/DD/YYYY">{cell}</Moment>;
    },
  },
];

const formatDateRange = (dateRangeValue) => {
  let startDate = '';
  let endDate = '';
  if (dateRangeValue) {
    startDate = moment(dateRangeValue[0])
      .startOf("day")
      .format("YYYY-MM-DD HH:mm:ss");
    endDate = moment(dateRangeValue[1])
      .endOf("day")
      .format("YYYY-MM-DD HH:mm:ss");
  }
  console.log("startDate", startDate);
  console.log("endDate", endDate);

  return { startDate, endDate };
};

export default function InfluencerDetails() {
  const { id } = useParams();
  const [influencerDetails, setInfluencerDetails] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingOrderDetails, setIsLoadingOrderDetails] = useState(false);
  const [assignProductsModal, setAssignProductsModal] = useState(false);
  const [influencerProducts, setInfluencerProducts] = useState([]);
  const [isAssigning, setIsAssigning] = useState(false);
  const [influencerOrders, setInfluencerOrders] = useState([]);
  const [dateRangeValue, setDateRangeValue] = useState(null);

  const { ExportCSVButton } = CSVExport;

  const getInfluencerInfo = useCallback(() => {
    setIsLoading(true);
    getInfluencerDetails(id)
      .then((res) => {
        setInfluencerDetails(res.data.influencerData);
        setInfluencerProducts(res.data.influencerProductsData);
      })
      .catch((err) => {
        console.error("Error getting influencer details:", err);
        toast.error("Failed to get influencer details");
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [id]);

  useEffect(() => {
    getInfluencerInfo();
  }, [getInfluencerInfo]);

  const getInfluencerOrders = useCallback(() => {
    setIsLoadingOrderDetails(true);
    const { startDate, endDate } = formatDateRange(dateRangeValue);
    getInfluencerOrderDetails(id, startDate, endDate)
      .then((res) => {
        setInfluencerOrders(res.data);
      })
      .catch((err) => {
        console.error("Error getting influencer order details:", err);
        toast.error("Failed to get influencer order details");
      })
      .finally(() => {
        setIsLoadingOrderDetails(false);
      });
  }, [id, dateRangeValue]);

  useEffect(() => {
    getInfluencerOrders();
  }, [getInfluencerOrders]);

  const openAssignProductsModal = () => {
    setAssignProductsModal(true);
  };

  const closeAssignProductsModal = () => {
    setAssignProductsModal(false);
  };

  const handleAssignProducts = (selectedProductIds) => {
    setIsAssigning(true);
    console.log("Assigning products", selectedProductIds, "to influencer", id);
    assignProductsToInfluencer(id, selectedProductIds)
      .then((res) => {
        console.log("Products assigned successfully", res.data);
        setInfluencerProducts(res.data.influencerProductsData);
        toast.success("Products assigned successfully");
      })
      .catch((err) => {
        console.error("Error assigning products", err);
        toast.error("Failed to assign products");
      })
      .finally(() => {
        setIsAssigning(false);
        closeAssignProductsModal();
      });
  };

  if (isLoading) {
    return (
      <>
        <Breadcrumbs
          title="Influencer Detail"
          parent="Influencers"
          subtitle={`Influencer ${id}`}
        />
        <div className="container-fluid">
          <div className="custom-loader">
            <Spinner animation="border" />
          </div>
        </div>
      </>
    );
  }

  if (!influencerDetails) {
    return (
      <>
        <Breadcrumbs
          title="Influencer Detail"
          parent="Influencers"
          subtitle={`Influencer ${id}`}
        />
        <div className="container-fluid">
          <Card className="card-box">
            <CardBody>
              <p>Influencer not found</p>
            </CardBody>
          </Card>
        </div>
      </>
    );
  }

  return (
    <>
      <Breadcrumbs
        title="Influencer Detail"
        parent="Influencers"
        subtitle={`Influencer ${influencerDetails.name}`}
      />
      <div className="container-fluid">
        <Row className="row">
          <Col md="12">
            <Card className="card-box mb-4">
              <CardBody>
                <Row className="align-items-center mb-4">
                  <Col md="12">
                    <h4 className="mb-0 text-none">
                      <strong>Influencer: {influencerDetails.name}</strong>
                    </h4>
                  </Col>
                </Row>

                <Row>
                  <Col md="6">
                    <div className="mb-3">
                      <strong className="mr-2">EMAIL:</strong>
                      {influencerDetails.email}
                    </div>
                    <div className="mb-3">
                      <strong className="mr-2">PHONE:</strong>
                      {formatPhoneNumber(influencerDetails.phone_number)}
                    </div>
                  </Col>
                  <Col md="6">
                    <div className="mb-3">
                      <strong className="mr-2">DATE CREATED:</strong>
                      {formatDate(influencerDetails.date_created)}
                    </div>
                    <div className="mb-3">
                      <strong className="mr-2">STATUS:</strong>
                      {influencerDetails.is_influencer_active
                        ? "Active"
                        : "Inactive"}
                    </div>
                  </Col>
                  <Col md="12">
                    <div className="mb-3">
                      <strong className="mr-2">CODE:</strong>
                      {influencerDetails.influencer_code}
                    </div>
                  </Col>
                </Row>
              </CardBody>
            </Card>
            <Card>
              <CardBody>
                <Row className="align-items-center mb-4">
                  <Col md="6">
                    <h4 className="text-none font-weight-bold">
                      Assigned Products
                    </h4>
                  </Col>
                  <Col md="6" className="text-right">
                    <Button
                      color="primary"
                      size="sm"
                      onClick={openAssignProductsModal}
                    >
                      Assign Products
                    </Button>
                  </Col>
                </Row>
                <ul className="list-group">
                  {influencerProducts
                    .filter((product) => product.is_assigned)
                    .map((product) => (
                      <li
                        key={product.id}
                        className="list-group-item d-flex justify-content-between align-items-center"
                      >
                        <Link
                          to={`/app/products/view-product/${product.product_id}`}
                        >
                          {product.name}
                        </Link>
                      </li>
                    ))}
                </ul>
              </CardBody>
            </Card>
            <Card className="card-box mb-4">
              <CardBody>
                <ToolkitProvider
                  keyField="id"
                  key="InfluencerOrdersTable"
                  data={influencerOrders || []}
                  columns={columns || []}
                  exportCSV={{
                    fileName: "influencer_orders.csv",
                  }}
                >
                  {(props) => (
                    <>
                      {/* <div className="d-flex align-items-center justify-content-between mb-4"> */}
                      <Row className="align-items-center mb-4">
                        <Col md="6">
                          <h4 className="text-none font-weight-bold">
                            Order Details
                          </h4>
                        </Col>
                        <Col
                          md="6"
                          className="d-flex justify-content-end align-items-center"
                        >
                          <DateRangePicker
                            onChange={(dates) => {
                              console.log("dates", dates);
                              setDateRangeValue(dates);
                            }}
                            value={dateRangeValue}
                            rangeDivider="to"
                            className="influencer-order-date-range-picker"
                          />
                          <ExportCSVButton
                            className="btn btn-primary ml-4"
                            {...props.csvProps}
                          >
                            <i className="fa fa-download mr-2"></i>
                            Export CSV
                          </ExportCSVButton>
                        </Col>
                      </Row>
                      {/* </div> */}
                      {isLoadingOrderDetails ? (
                        <div className="text-center">
                          <Spinner animation="border" />
                        </div>
                      ) : (
                        <BootstrapTable
                          {...props.baseProps}
                          noDataIndication="No orders available"
                          pagination={paginationFactory({
                            sizePerPage: 10,
                            showTotal: true,
                            hideSizePerPage: true,
                          })}
                        />
                      )}
                    </>
                  )}
                </ToolkitProvider>
              </CardBody>
            </Card>
            <AssignProductsModal
              isOpen={assignProductsModal}
              toggle={closeAssignProductsModal}
              products={influencerProducts}
              onSubmit={handleAssignProducts}
              isSubmitting={isAssigning}
            />
          </Col>
        </Row>
      </div>
    </>
  );
}
